module.exports = __webpack_public_path__ + "img/2-phone.e1599914.jpg";